import styled from 'styled-components'
import { LIGHT_THEME_NAME } from '@/constants/names'
import { Link } from 'react-router-dom'

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.colors.default};
  ${({ to }) => to === '#' && `
    opacity: 0.2;
    // pointer-events: none;
  `}
`

export const ColumnsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: ${({ theme }) =>
    `calc(100vh - ${(theme.sizes.headerHeight + theme.sizes.menuRowHeight)}px)`
};
  overflow-y: auto;
  overflow-x: hidden;

  ${({ theme }) => {
    if (theme.themeName === LIGHT_THEME_NAME) {
      return `
        &:not(:first-child) {
          margin-top: 10px;
        }
      `
    }
    return `
      &:first-child {
        margin-top: 10px;
      }
    `
  }}

  &:not(:first-child) {
    margin-top: 10px;
  }
`

export const Icon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin: 5px 10px;
`

export const TitleRow = styled.div`
  display: flex;
  ${({ showTitle }) => showTitle && `
    display: none;
  `}
  ${({ theme }) => {
    if (theme.themeName === LIGHT_THEME_NAME) {
      return `
        width: 180px;
      `
    }
    return `
      width: 200px;
    `
  }}
`

export const Title = styled.h3`
  font-family: 'Roboto', sans-serif;
  cursor: pointer;
  height: 100%;
  display: block;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  ${({ isBigChildren }) => isBigChildren && `
    overflow: hidden;
  `}
  ${({ theme }) => {
    if (theme.themeName === LIGHT_THEME_NAME) {
      return `
        font-size: 1.2rem;
        font-weight: 500;
      `
    }
    return `
      font-weight: ${theme.fontWeights.bold};
      font-size: 1.4rem;
      line-height: 2.4rem;
    `
  }}
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  &:hover {
    background: ${({ theme }) => theme.colors.colors.default};
    color: ${({ theme }) => theme.colors.backgrounds.default};

    svg {
      .svgFill {
        fill: ${({ theme }) => theme.colors.backgrounds.default};
      }
      .svgStroke {
        stroke: ${({ theme }) => theme.colors.backgrounds.default};
      }
    }
  }
`

export const FoldButton = styled(Row)`
  cursor: pointer;
  display: flex;
  align-items: center;
  height: ${({ theme }) => theme.sizes.menuRowHeight}px;
  border-top: 1px solid ${({ theme }) => theme.colors.borders.default};
  z-index: 1;
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`
